import api from '../../services/api'

const services = {
  getIdSubscriptionPlan(idSubscriptionPlan) {
    return api.get(`/subscriptionplan/active/${idSubscriptionPlan}`)
  },
}

export default services
